<template>
	<div>
		<div class="tip">
			我们鼓励积极向上、真实、原创的内容，严禁不文明语言、营销推广售卖商品等行为，一经发现立即删除内容/冻结用户账号！
		</div>
		<div class="publish">
			<div class="title flex flex-align-center flex-jus-between">
				<div>分享今日动态</div>
				<img src="@/static/images/index/close.png" alt=""  @click="$router.go(-1)">
			</div>
			
			<div class="textarea">
				<textarea placeholder="请输入您的分享内容（200字以内）..." maxlength="200" v-model="brief"></textarea>
				<div class="inputText">{{ brief.length }}/200</div>
			</div>

			<div>
				<div @click="popShow=true" style="margin: 20px 0" class="flex flex-align-center flex-jus-between">
					<div class="label">选择文件类型</div>
					<div>
						<span v-if="!type" class="choose-text">请选择</span>
						<span v-else class="black-text">{{type == 1 ? '图片' : '视频'}}</span>
						<img class="right-icon" src="@/static/images/icon-arrowRight.png" alt="">
					</div>
				</div>
				<van-popup v-model="popShow" round position="bottom">
					<van-picker
						title="选择文件类型"
						show-toolbar
						:columns="typeList"
						@confirm="typeConfirm"
						@cancel="typeCancel"
					/>
				</van-popup>
			</div>
			
			<template v-if="type == 1">
				<van-uploader v-model="fileList" multiple :max-count="9" :after-read="afterImgRead"/>
			</template>

			<template v-if="type == 2">
				<van-uploader v-model="videoList" :max-size="50000 * 1024"  @oversize="onOversize" :max-count="1" :after-read="afterVideoRead" accept="video/*" />
			</template>
			
			
			<div @click="publish" class="submitBtn">发布</div>
		</div>
		<div v-if="loading" class="mask flex flex-align-center flex-jus-center">
			<div style="text-align:center">
				<van-loading size="36" color="#FFF"/>
				<div style="color:#fff;font-size:18px">
					发布中...
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	/* eslint-disable */
	export default {
		watch: {
		},
		data() {
			return{
				type: '',
				brief: '',
				content: '',
				pic: '',
				popShow: false,
				typeList: [
					{
						text: '图片',
						id: '1'
					},
					{
						text: '视频',
						id: '2'
					}
				],
				fileList: [],
				imgs: [],
				videoList: [],
				videoSrc: '',
				loading: false
			}
		},
		created() {

		},
		mounted() {
			this.$wx.ready(() => {
				this.$wx.updateAppMessageShareData({
					title: '福建省民族管弦乐学会',
					desc: '福建省民族管弦乐学会',
					link: location.href,
					imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
				})
				this.$wx.updateTimelineShareData({
					title: '福建省民族管弦乐学会',
					link: location.href,
					imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
				})
			});
		},
		methods: {
			typeConfirm(e) {
				this.type = e.id
				this.popShow = false
			},
			typeCancel() {
				this.popShow = false
			},
			afterImgRead() {},
			afterVideoRead(file) {
				file.status = 'uploading';
				file.message = '上传中...';
				let formData= new FormData();
				formData.append("file", file.file);
				this.$post('api/common/upload', formData, {
					'Content-Type':'multipart/form-data'
				}).then(res => {
					this.videoSrc = res.data.src
					this.pic = res.data.image_src
					file.status = 'done'
				})
			},
			onOversize() {
				this.$toast('视频文件大小不能超过 50M');
			},
			async uploadImg(file) {
				let formData= new FormData();
				formData.append("file", file);
				await this.$post('api/common/upload', formData,{
					'Content-Type':'multipart/form-data'
				}).then(res => {
					this.imgs.push(res.data.src)
				})
			},
			async publish() {
				if (!this.brief) {
					this.$toast('请输入内容')
					return
				}
				if (!this.type) {
					this.$toast('请选择文件类型')
					return
				}
				this.loading = true
				for(let i = 0; i < this.fileList.length;i++) {
					await this.uploadImg(this.fileList[i].file)
				}
				let content = ''
				if (this.type == 1) {
					content = this.imgs.toString()
				} else {
					content = this.videoSrc
				}
				if (!content) {
					this.$toast('请上传文件')
					this.loading = false
					return 
				}
				
				this.$post('api/circle/circlePush', {
					type: this.type,
					brief: this.brief,
					content,
					pic: this.pic
				}).then(() => {
					this.loading = false
					this.$toast('发布成功')
					setTimeout(() => {
						this.$router.replace({'name': 'friends'})
					}, 750);
				})
			}
		}
	}
</script>

<style scoped lang="stylus">
.tip
	font-size 24px
	color #DE8C17
	line-height 44px
	background #FCF6ED
	padding 16px 30px
.submitBtn
	margin 50px auto 0 auto
	width 376px
	height 92px
	line-height 92px
	text-align center
	background-image url('~@/static/images/index/btnBG.png')
	background-size 100% 100%
	background-position center
	font-size: 32px;
	color: #FFFFFF;
.publish
	padding 24px 30px
	.title
		margin-bottom 36px
		font-size: 36px;
		font-weight: bold;
		color: #000000;
		img
			width 44px
			height 44px
	.tips
		margin-top 30px
		margin-bottom 30px
		width 100%
		font-size 26px
		font-weight bold
	.textarea
		width 100%
		height 480px
		padding 24px
		background: #F7F7F7;
		border-radius: 20px;
		color: #B1B1B1;
		position relative
		.inputText
			position absolute
			right 24px
			bottom 24px
			font-size: 24px;
			color: #DE113C;
		textarea
			width 100%
			height 100%
			background-color inherit
			border none
			resize none
			font-size 26px
			color #000000
		textarea::-webkit-input-placeholder
			font-size: 28px;
			color: #B1B1B1;
		textarea:-moz-placeholder
			font-size: 28px;
			color: #B1B1B1;
		textarea::-moz-placeholder
			font-size: 28px;
			color: #B1B1B1;
		textarea::-ms-input-placeholder
			font-size 28px
			color #B1B1B1
.label
	font-size 32px
	font-weight bold
	margin-top 12px
.choose-text
	font-size 28px
	color #b1b1b1
	line-height 40px
	margin-right 28px
.black-text
	font-size 28px
	color #000
	line-height 40px
	margin-right 28px
.right-icon
	width 12px
	height 24px
</style>
